// @ts-nocheck
import Link from "@store/MobiusOverrides/Link/Link";
import { ProductContextsBySku } from "@store/Framework/Common/Hooks/useProductContextsBySku";
import React from "react";
import { css } from "styled-components";

// Skus occasionally have white space in them, so we need to trim them.
// Some items have the order of measure in the item number, so we need to remove that as well.
export const getFixedSku = (sku: string) => {
    if (typeof sku === "string") {
        return sku.replace("EA", "").trim();
    }
    return sku;
};

const useReportingProductLinkFormatting = (
    nameKey: string,
    skuKey: string,
    reportData: Record<string, any>[] | undefined,
    productContextsBySku: ProductContextsBySku,
) => {
    const getProductLinkFieldByName = (name: string) => {
        if (reportData && nameKey in reportData[0] && skuKey in reportData[0] && productContextsBySku) {
            const sku = reportData.find(item => item?.[nameKey] === name)?.[skuKey];

            const fixedSku = getFixedSku(sku);
            const product = productContextsBySku?.[fixedSku]?.product;
            if (product) {
                const nameToUse = product?.productTitle ?? name;
                return (
                    <Link
                        mergeCss
                        css={css`
                            max-width: 20vw;
                            overflow: hidden;
                        `}
                        typographyProps={{ ellipsis: true }}
                    >
                        {nameToUse}
                    </Link>
                );
            }
        }

        return name;
    };
    const getProductLinkBySku = (sku: string) => {
        if (reportData && skuKey in reportData[0] && productContextsBySku) {
            const fixedSku = getFixedSku(sku);
            if (fixedSku && fixedSku in productContextsBySku && productContextsBySku[fixedSku]?.product) {
                return <Link href={`${productContextsBySku[fixedSku]?.product?.canonicalUrl}`}>{sku}</Link>;
            }
        }
        return sku;
    };

    return { getProductLinkFieldByName, getProductLinkBySku };
};

export default useReportingProductLinkFormatting;
